import ApiService from '@/api';
import GetEmployeesListRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/request/GetEmployeesListRequest';
import EnumUserStatus from '@/api/Main/dataSource/api/users/base/enums/EnumUserStatus';
import { ResponseModel } from '@/models';
import { UserModel } from '@/components/task-forms/models';
import { CurrentUser, UserRoleEnum } from 'tir-pm-user-core';
import OwnedUsersRequest from '@/api/Main/dataSource/api/projects/performers/i-service/model/request/OwnedUsersRequest';
import InviteToEstimateRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/estimate/InviteToEstimateRequest';
import RemoveInviteFromEstimateRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/estimate/RemoveInviteFromEstimateRequest';
import RemoveEstimatePerformerRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/RemoveEstimatePerformerRequest';
import { TirPmNotificationEventBus, TirPmNotificationModel } from 'tir-components';
import EstimatePerformerSaveRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/request/EstimatePerformerSaveRequest';
import UpsertFinalEstimateRequest from '@/api/Main/dataSource/api/projects/task/i-service/models/task/response/UpsertFinalEstimateRequest';

/**Сервис управления API */
export class AdapterService {
  /**Сервис использования API */
  api = new ApiService();

  /**Получить список сотрудников текущего пользователя */
  getEmployeesForManagerList() {
    return new Promise<ResponseModel<UserModel[]>>(async (resolve) => {
      const result = new ResponseModel<UserModel[]>();

      const query = CurrentUser.Roles.includes(UserRoleEnum.Owner)
        ? this.api.Main.PerformersListService.getOwnedUsersAsync(
            new OwnedUsersRequest({
              StatusList: [EnumUserStatus.Active],
            }),
          )
        : this.api.Main.EmployeeService.getEmployeesForManagerListAsync(
            new GetEmployeesListRequest({
              Statuses: [EnumUserStatus.Active],
            }),
          );

      await query
        .then((response) => {
          result.Value = response.Items.map(
            (x) =>
              new UserModel({
                Id: x.UserId,
                FirstName: x.FirstName,
                LastName: x.LastName,
                AvatarColor: x.AvatarColor,
                ImageUrl: x.Foto,
              }),
          );
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getEmployeesForManagerList', e);
          return resolve(result);
        });
    });
  }
  /**Приглашение на оценку */
  inviteToEstimate(taskId: number, userIds: number[]) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.EstimateInviteService.inviteToEstimateAsync(
        new InviteToEstimateRequest({
          TaskId: taskId,
          UserIds: userIds,
        }),
      )
        .then(() => resolve(result))
        .catch((error) => {
          result.IsSuccess = false;
          console.error(error);
          return resolve(result);
        });
    });
  }
  /**Удаление оценки времени */
  removeEstimateTime(taskId: number, performerId: number) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.ProjectTaskSaveService.removeEstimatePerformerAsync(
        new RemoveEstimatePerformerRequest({
          TaskId: taskId,
          PerformerId: performerId,
        }),
      )
        .then(() => resolve(result))
        .catch((error) => {
          result.IsSuccess = false;
          console.error(error);
          this.sendErrorNotification(error);
          return resolve(result);
        });
    });
  }
  /**Удаление приглашения */
  removeEstimateInvite(taskId: number, userId: number) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.EstimateInviteService.removeInviteFromEstimateAsync(
        new RemoveInviteFromEstimateRequest({
          TaskId: taskId,
          UserId: userId,
        }),
      )
        .then(() => resolve(result))
        .catch((error) => {
          result.IsSuccess = false;
          console.error(error);
          this.sendErrorNotification(error);
          return resolve(result);
        });
    });
  }
  /**Обновление оценки */
  upsertEstimate(taskId: number, estimate: number, performerId: number) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.ProjectTaskSaveService.upsertEstimatePerformerAsync(
        new EstimatePerformerSaveRequest({
          TaskId: taskId,
          Estimate: estimate,
          PerformerId: performerId,
        }),
      )
        .then(() => resolve(result))
        .catch((error) => {
          result.IsSuccess = false;
          console.error(error);
          this.sendErrorNotification(error);
          return resolve(result);
        });
    });
  }
  /**Обновление финальной оценки */
  upsertFinalEstimate(taskId: number, estimate: number) {
    return new Promise<ResponseModel<boolean>>((resolve) => {
      const result = new ResponseModel<boolean>();
      this.api.Main.ProjectTaskSaveService.upsertFinalEstimateAsync(
        new UpsertFinalEstimateRequest({
          TaskId: taskId,
          Estimate: estimate,
        }),
      )
        .then(() => resolve(result))
        .catch((error) => {
          result.IsSuccess = false;
          console.error(error);
          this.sendErrorNotification(error);
          return resolve(result);
        });
    });
  }

  /**Отправка уведомления с ошибкой */
  sendErrorNotification(error: any) {
    TirPmNotificationEventBus.emit(
      'add',
      new TirPmNotificationModel({
        title: 'Ошибка',
        subtitle: error?.ErrorMessage || error,
        type: 'error',
        group: 'general',
        life: 5000,
        closable: true,
      }),
    );
  }
}
